import type { ReactNode } from 'react';

interface CardProps {
  title?: string;
  note?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}

export function Card({ title, note, action, children }: CardProps) {
  return (
    <section className="card">
      {(title || note || action) && (
        <header className="card__head">
          <div>
            {title && <h2 className="card__title">{title}</h2>}
            {note && <div className="card__note">{note}</div>}
          </div>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
